var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"las la-2x",class:_vm.value? `la-check yes` : `la-times no`})])
}
var staticRenderFns = []

export { render, staticRenderFns }